// extracted by mini-css-extract-plugin
export var business_form = "businessForm-module--business_form--e31a6";
export var business_form_heading = "businessForm-module--business_form_heading--e7380";
export var business_form_left = "businessForm-module--business_form_left--562aa";
export var business_form_listing = "businessForm-module--business_form_listing--210fd";
export var business_form_right = "businessForm-module--business_form_right--86b2c";
export var business_form_wrap = "businessForm-module--business_form_wrap--798d7";
export var check_Box = "businessForm-module--check_Box--95d55";
export var check_box_grp = "businessForm-module--check_box_grp--5adfc";
export var contact_info_box = "businessForm-module--contact_info_box--80f05";
export var forcesRed = "businessForm-module--forces-red--b2bb2";
export var form_grp = "businessForm-module--form_grp--aeaf3";
export var full_col = "businessForm-module--full_col--730bd";
export var heading_title = "businessForm-module--heading_title--ff07d";
export var icon_Box = "businessForm-module--icon_Box--078a7";
export var inner_box = "businessForm-module--inner_box--d4c0d";
export var input_grp = "businessForm-module--input_grp--93bd4";
export var it_form_section = "businessForm-module--it_form_section--b3da2";
export var pictureDiv = "businessForm-module--pictureDiv--be076";
export var review_list = "businessForm-module--review_list--c9775";
export var rightLabel = "businessForm-module--rightLabel--35158";
export var rightReviewList = "businessForm-module--rightReviewList--2a2f3";
export var submit_area = "businessForm-module--submit_area--671fb";
export var two_col = "businessForm-module--two_col--1f664";